import React, { memo } from 'react';

import CustomCopyToClipboard from 'components/CustomCopyToClipboard';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';

interface IProps {
  productId: number | string;
  copiedCheckout: () => void;
  className?: string;
}

const ShareableLinks = ({ productId, copiedCheckout }: IProps) => {
  return (
    <div className='flex flex-col gap-2'>
      <div>
        <label className='text-text-secondary mb-1 block text-xs font-medium'>Novo Checkout Sun</label>
        <CustomCopyToClipboard
          text={`${CHECKOUT_ELEMENTS_URL}/${productId}`}
          disableUnderline
          style={{ width: '100%' }}
          onCopy={copiedCheckout}
        />
      </div>
      <div>
        <label className='text-text-secondary mb-1 block text-xs font-medium'>Checkout Sun</label>
        <CustomCopyToClipboard
          text={`${CHECKOUT_SUN_URL}/${productId}`}
          disableUnderline
          fullWidth
          style={{ width: '100%' }}
          onCopy={copiedCheckout}
        />
      </div>
    </div>
  );
};

export default memo(ShareableLinks);
